import styled from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _LandingInnovationPetitPrinceRoot = styled("section")(() => {
  return {
    width: "100%",
    position: "relative" as const,
    zIndex: 1,
  };
});

export const _LandingInnovationPetitPrinceGrid = styled("div")(() => {
  return {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    padding: "48px",
    gap: "16px",
    width: "100%",
    maxWidth: "1440px",
    margin: "0 auto",
    [`@media ${responsiveMap.mobile}`]: {
      gridTemplateColumns: "repeat(1, 1fr)",
      padding: "0",
      gap: "24px",
    },
  };
});
